import ReactSlider, { ReactSliderProps } from 'react-slider';
import FormGroupWrap from '@/library/components/form/helpers/FormGroupWrap';
import { FC, ReactNode } from 'react';

// Type assertion to work around React 18 type incompatibility
const SliderComponent = ReactSlider as unknown as FC<ReactSliderProps>;

export interface SliderProps extends ReactSliderProps {
  disabled?: boolean;
  error?: string | null;
  className?: string;
  label?: ReactNode;
  dataCy?: string;
  color?: string;
}

const Slider: FC<SliderProps> = ({
  disabled = false,
  renderThumb,
  error,
  className,
  label,
  dataCy,
  color = 'moody-blue',
  ...rest
}) => {
  return (
    <FormGroupWrap
      className={`mb-0 w-100p ${className || ''}`}
      label={label}
      error={error}
      dataCy={dataCy}
    >
      <SliderComponent
        className={`slider-input text-${color}`}
        thumbClassName="slider-input--thumb"
        trackClassName="slider-input--track"
        renderThumb={(props, state) =>
          renderThumb ? renderThumb(props, state) : <div {...props}>{state.valueNow}</div>
        }
        disabled={disabled}
        {...rest}
      />
    </FormGroupWrap>
  );
};

export default Slider;
